import { useEffect, useState } from "react";
import axios from "axios";
import usePageTitle from "@/hooks/use-page-title";
import { Camera } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Placeholder tiles for when no uploads exist yet
const PLACEHOLDERS = Array.from({ length: 12 }).map((_, i) => ({
  id: `p${i}`,
  placeholder: true,
  category: ["Signage", "Banner", "Vehicle", "Corporate", "Retail", "Event"][i % 6],
}));

export default function Portfolio() {
  usePageTitle("Portfolio");
  const [photos, setPhotos] = useState([]);
  useEffect(() => {
    axios.get(`${API}/media?category=portfolio`).then((r) => setPhotos(r.data));
  }, []);
  const tiles = photos.length ? photos : PLACEHOLDERS;
  return (
    <div className="py-20 max-w-7xl mx-auto px-4 lg:px-8">
      <div className="text-center mb-14">
        <div className="overline mb-2">Portfolio</div>
        <h1 className="font-display text-5xl md:text-6xl font-black tracking-tighter">Selected Work</h1>
        <p className="mt-4 text-zinc-600 max-w-2xl mx-auto">
          A curated look at projects delivered for retail chains, corporates and event teams.
        </p>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {tiles.map((t, i) => (
          <div
            key={t.id}
            className={`relative rounded-2xl overflow-hidden bg-gradient-to-br from-zinc-100 to-orange-50 border border-zinc-200 hover:border-[#FF6B00] transition-all group ${i % 3 === 0 ? "aspect-[4/5]" : "aspect-square"}`}
          >
            {t.placeholder ? (
              <div className="absolute inset-0 flex items-center justify-center text-zinc-300">
                <Camera size={48} />
              </div>
            ) : (
              <img src={`${API}/media/${t.id}`} alt={t.label} className="w-full h-full object-cover" />
            )}
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
            <div className="absolute bottom-3 left-3 right-3 text-white opacity-0 group-hover:opacity-100 transition-opacity">
              <div className="text-xs uppercase tracking-widest text-[#FF6B00] font-bold">{t.category || "Project"}</div>
              <div className="font-bold text-sm">{t.label || `Project #${String(i + 1).padStart(3, "0")}`}</div>
            </div>
          </div>
        ))}
      </div>
      <div className="text-center mt-10 text-sm text-zinc-500">
        Interested in the full portfolio? <a href="mailto:print@brothersdigital.in" className="text-[#FF6B00] font-semibold">Email us</a> — we'll send curated case studies.
      </div>
    </div>
  );
}
